"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _iconChevronDownExtraSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-chevron-down-extra-small"));
var _iconChevronDownSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-chevron-down-small"));
var _RotatingContainer = _interopRequireDefault(require("../helpers/RotatingContainer"));
var _layout = require("../layout");
var _propTypes = require("../prop-types");
var _utils2 = require("../utils");
var _ExpanderContent = _interopRequireDefault(require("./ExpanderContent"));
var _constants = require("./constants");
var _helperComponents = require("./helperComponents");
var _helpers = require("./helpers");
var _interfaces = require("./interfaces");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Expander = _ref => {
  let {
    'aria-describedby': ariaDescribedby,
    chevronPosition: chevronPositionProp,
    children,
    contentPadding: contentPaddingProp,
    contentSpacing = _constants.expanderDefaultProps.contentSpacing,
    hasBoldTitle,
    headingLevel,
    isExpanded: isExpandedProp,
    layout = _constants.expanderDefaultProps.layout,
    onToggle,
    renderTitle = _helpers.defaultTitleRenderer,
    shouldExpandOnMount = _constants.expanderDefaultProps.shouldExpandOnMount,
    shouldAnimate = _constants.expanderDefaultProps.shouldAnimate,
    size = _constants.expanderDefaultProps.size,
    titleRendererProps,
    titleText,
    triggerButtonProps,
    ...forwardedProps
  } = _ref;
  const [idNumber] = (0, _react.useState)((0, _utils2.getUniqueId)());
  const [isExpandedState, setIsExpandedState] = (0, _react.useState)(shouldExpandOnMount);
  const id = "StencilExpander-".concat(idNumber);
  const isCardLayout = layout === _interfaces.ExpanderLayout.Card;
  const isSmall = size === _interfaces.ExpanderSize.Small;
  const expanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedState;
  const toggle = () => {
    setIsExpandedState(!expanded);
    !!onToggle && onToggle(!expanded);
  };
  const chevronPosition = (0, _helpers.getChevronPosition)({
    isCardLayout,
    chevronPositionProp
  });
  const IconChevron = isSmall ? _iconChevronDownExtraSmall.default : _iconChevronDownSmall.default;
  const triggerButton = (0, _react2.jsx)(_helperComponents.ExpanderTriggerButton, (0, _extends2.default)({}, triggerButtonProps, {
    "aria-describedby": ariaDescribedby,
    icon: (0, _react2.jsx)(_RotatingContainer.default, {
      isRotated: expanded
    }, (0, _react2.jsx)(IconChevron, {
      color: (0, _utils.token)('color.icon.primary-default'),
      title: titleText
    })),
    iconAltText: titleText,
    isExpanded: expanded,
    onClick: toggle
  }));
  const chevron = headingLevel ? (0, _react2.jsx)("div", {
    "aria-level": headingLevel,
    role: "heading"
  }, triggerButton) : triggerButton;
  const Container = isCardLayout ? _helperComponents.CardCol : _layout.Col;
  const TitleRow = isCardLayout ? _helperComponents.ClickableRow : _layout.Row;
  const contentPadding = contentPaddingProp === undefined && isCardLayout ? [0, 'S300', 'S300'] : contentPaddingProp || 0;
  return (0, _react2.jsx)(Container, (0, _extends2.default)({
    padding: 0
  }, (0, _utils2.pickDataProps)(forwardedProps)), (0, _react2.jsx)(TitleRow, {
    onClick: isCardLayout ? toggle : undefined,
    padding: isCardLayout ? ['S200', 'S300'] : undefined,
    alignItems: "center",
    gridGap: isSmall ? 'S100' : 'S200'
  }, chevronPosition === _interfaces.ExpanderChevronPosition.Leading && chevron, (0, _react2.jsx)(_layout.Row, {
    id: id,
    "data-test-component": "StencilExpanderTitle",
    flex: 1
  }, renderTitle({
    hasBoldTitle,
    headingLevel,
    size,
    titleText,
    toggle,
    ...titleRendererProps
  })), chevronPosition === _interfaces.ExpanderChevronPosition.Trailing && chevron), (0, _react2.jsx)(_ExpanderContent.default, {
    padding: contentPadding,
    isExpanded: expanded,
    topSpacing: contentSpacing,
    shouldAnimate: shouldAnimate
  }, children));
};
var _default = exports.default = (0, _utils2.composeStencilComponent)({
  baseComponent: Expander,
  defaultProps: _constants.expanderDefaultProps,
  description: 'Container which shows and hides content, controlled by a trigger button.',
  displayName: 'Expander',
  propTypes: {
    'aria-describedby': _stencilReactDesc.PropTypes.string.description("Sets the 'aria-describedby' attribute in the DOM for the trigger button. Generally, this prop SHOULD NOT be used. In Stencil it's used internally in the Select component with multi selection."),
    chevronPosition: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ExpanderChevronPosition)).description('Customizes the position of the chevron.'),
    children: _stencilReactDesc.PropTypes.node.description('Content to display in the container.'),
    contentPadding: (0, _propTypes.cssPadding)().description('Padding for the expandable content.'),
    contentSpacing: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.number, _stencilReactDesc.PropTypes.string]).description('Spacing between the title and the expandable content.'),
    hasBoldTitle: _stencilReactDesc.PropTypes.bool.description('Whether the expander title is rendered as bold. If any headingLevel is set the title is always rendered as bold.'),
    headingLevel: _stencilReactDesc.PropTypes.oneOf([1, 2, 3, 4, 5, 6]).description('Determines the appropriate tag for the Expander title.'),
    size: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ExpanderSize)).description('Sets the size of the expander.'),
    isExpanded: _stencilReactDesc.PropTypes.bool.description('Overrides the state of the component to control whether it is expanded or collapsed.'),
    layout: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ExpanderLayout)).description('Determines how the content of the component is displayed.'),
    onToggle: _stencilReactDesc.PropTypes.func.description('Callback called when the trigger button is clicked. The argument will be the new state of the component.').format('(isExpanded: boolean) => void'),
    shouldExpandOnMount: _stencilReactDesc.PropTypes.bool.description('Whether the component should expand by default on first render.'),
    shouldAnimate: _stencilReactDesc.PropTypes.bool.description('Prop to enable or disable expanding animation.'),
    titleText: _stencilReactDesc.PropTypes.string.isRequired.description('Title to display above the expandable content.'),
    triggerButtonProps: _stencilReactDesc.PropTypes.object.description('Props that will be passed to the trigger button.'),
    titleRendererProps: _stencilReactDesc.PropTypes.object.description('Props that will be passed to the title renderer.'),
    renderTitle: _stencilReactDesc.PropTypes.func.description('Customizes how the title is displayed.').format("({\n  headingLevel: ExpanderTitleHeadingLevel,\n  size: ExpanderSize, \n  titleText: string,\n  toggle: () => void,\n  ...titleRendererProps\n}) => ReactNode")
  }
});